module.exports = __webpack_public_path__ + "static/media/Illus-LoyaltySpring.abf1a985.png";